export default __webpack_public_path__ + "static/PromptIconOne-d3ad9bdbc6abfed1d3fdaf220b22884f.png";